import { render, staticRenderFns } from "./ResetContext.vue?vue&type=template&id=081d6557&"
import script from "./ResetContext.vue?vue&type=script&lang=js&"
export * from "./ResetContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports